var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Retriever } from "../../../../common";
import { SportModel, itemIDs } from "../..";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class FavoritesRetriever extends Retriever {
    constructor(messageBus, isFavoritesFirst, blockId, dict, cookies) {
        super();
        this.favoriteItemId = itemIDs.favorites;
        this.cookieName = `favoriteEvents_${blockId}`;
        this.messageBus = messageBus;
        this.isFavoritesFirst = isFavoritesFirst;
        this.dict = dict;
        this.cookies = cookies;
        this.addFavoritesSubscription = () => { };
        this.removeFavoritesSubscription = () => { };
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            const count = this.getFavoriteEventsCountFromCookie();
            if (count > 0) {
                state.add(this.getFavoritesItem(count));
            }
            this.addFavoritesSubscription = this.messageBus.getSubscription(InternalMessageBusChannels.favoriteEvents.add, () => this.addFavorites(state), this);
            this.removeFavoritesSubscription = this.messageBus.getSubscription(InternalMessageBusChannels.favoriteEvents.remove, () => this.removeFavorites(state), this);
        });
    }
    getFavoritesItem(count) {
        return new SportModel({
            id: this.favoriteItemId,
            name: this.dict.favorites,
            numberOfEvents: count,
            order: this.isFavoritesFirst ? -3 : 1000
        }, "favorites");
    }
    getFavoriteEventsCountFromCookie() {
        const selectedEvents = this.cookies.get(this.cookieName);
        return selectedEvents ? selectedEvents.split(",").length : 0;
    }
    addFavorites(state) {
        const favoritesItem = state.getItemById(this.favoriteItemId);
        if (favoritesItem) {
            state.update(this.favoriteItemId, { numberOfEvents: favoritesItem.numberOfEvents + 1 }, true);
        }
        else {
            state.add(this.getFavoritesItem(1));
        }
    }
    removeFavorites(state) {
        const favoritesItem = state.getItemById(this.favoriteItemId);
        if (favoritesItem) {
            const newCount = favoritesItem.numberOfEvents - 1;
            if (newCount) {
                state.update(this.favoriteItemId, { numberOfEvents: newCount }, true);
            }
            else {
                state.remove(this.favoriteItemId, true);
            }
        }
    }
    deactivate() {
        this.addFavoritesSubscription();
        this.removeFavoritesSubscription();
    }
}
//# sourceMappingURL=FavoritesRetriever.js.map